<div class="modal-header">
    <i class="fa-regular fa-circle-xmark fa-2x fa-fw" (click)="closeModal()"></i>
</div>
<div class="image-container">
    <img [src]="data.imageUrl" alt="Full Image" />
</div>
